// Bildirimler Mock Verileri

// Admin (Yönetici) Bildirimleri - Finansal
export const adminBildirimleri = [
    {
        id: 'admin-1',
        type: 'payment',
        severity: 'success',
        title: 'Ödeme Alındı',
        message: 'Emre Karaca, A-101 dairesi için 200.000 ₺ taksit ödemesi yaptı.',
        isRead: false,
        createdAt: '2026-01-18T14:30:00',
        link: '/finans/musteriler/ind-1',
    },
    {
        id: 'admin-2',
        type: 'warning',
        severity: 'warning',
        title: 'Gecikmiş Taksit',
        message: 'Elif Tuncer\'ın B-101 dairesi için taksit ödemesi 5 gün gecikti.',
        isRead: false,
        createdAt: '2026-01-18T10:15:00',
        link: '/finans/taksitler',
    },
    {
        id: 'admin-3',
        type: 'info',
        severity: 'info',
        title: 'Yeni Rezervasyon',
        message: 'C-301 dairesi Burak Özdemir tarafından rezerve edildi. Kapora: 2.000.000 ₺',
        isRead: false,
        createdAt: '2026-01-17T16:45:00',
        link: '/finans/daireler',
    },
    {
        id: 'admin-4',
        type: 'payment',
        severity: 'success',
        title: 'Hakediş Ödemesi',
        message: 'Demir Yapı İnşaat\'a 1.500.000 ₺ hakediş ödemesi yapıldı.',
        isRead: true,
        createdAt: '2026-01-17T11:20:00',
        link: '/finans/firmalar/comp-1',
    },
    {
        id: 'admin-5',
        type: 'critical',
        severity: 'critical',
        title: 'Vade Tarihi Yaklaşıyor',
        message: 'Anadolu Beton\'a 800.000 ₺ ödeme vadesi 3 gün sonra.',
        isRead: false,
        createdAt: '2026-01-16T14:00:00',
        link: '/finans/harcamalar',
    },
    {
        id: 'admin-6',
        type: 'success',
        severity: 'success',
        title: 'Satış Tamamlandı',
        message: 'Oğuz Yalçın, A-401 dairesini peşin ödeme ile satın aldı.',
        isRead: true,
        createdAt: '2026-01-15T15:30:00',
        link: '/finans/daireler',
    },
    {
        id: 'admin-7',
        type: 'error',
        severity: 'error',
        title: 'Ödeme Hatası',
        message: 'Ceren Aksoy\'un otomatik taksit çekimi başarısız oldu.',
        isRead: false,
        createdAt: '2026-01-15T10:45:00',
        link: '/finans/taksitler',
    },
];

// Şef (Şantiye Şefi) Bildirimleri - Operasyonel
export const sefBildirimleri = [
    {
        id: 'sef-1',
        type: 'personel',
        severity: 'info',
        title: 'Yeni Personel Atandı',
        message: 'Ahmet Çelik şantiyenize yeni işçi olarak atandı.',
        isRead: false,
        createdAt: '2026-01-18T08:30:00',
        link: '/insaat/personel',
    },
    {
        id: 'sef-2',
        type: 'malzeme',
        severity: 'info',
        title: 'Malzeme Teslimatı',
        message: 'Çimento siparişi yarın saat 09:00\'da teslim edilecek.',
        isRead: false,
        createdAt: '2026-01-18T07:00:00',
        link: '/insaat/kaba/beton',
    },
    {
        id: 'sef-3',
        type: 'uyari',
        severity: 'warning',
        title: 'Hava Durumu Uyarısı',
        message: 'Yarın için yağmur bekleniyor. Dış mekan çalışmalarını planlayın.',
        isRead: true,
        createdAt: '2026-01-17T18:00:00',
        link: null,
    },
    {
        id: 'sef-4',
        type: 'gorev',
        severity: 'warning',
        title: 'Günlük Rapor Hatırlatması',
        message: 'Bugünün şantiye günlüğünü girmeyi unutmayın.',
        isRead: false,
        createdAt: '2026-01-17T17:00:00',
        link: '/insaat/gunluk',
    },
    {
        id: 'sef-5',
        type: 'onay',
        severity: 'success',
        title: 'İş Tamamlandı',
        message: 'A Blok 2. kat kaba inşaat tamamlandı olarak işaretlendi.',
        isRead: true,
        createdAt: '2026-01-17T16:00:00',
        link: '/insaat/projeler',
    },
    {
        id: 'sef-6',
        type: 'malzeme',
        severity: 'error',
        title: 'Stok Uyarısı',
        message: 'Demir stoku kritik seviyenin altına düştü!',
        isRead: false,
        createdAt: '2026-01-16T14:30:00',
        link: '/insaat/kaba/demir',
    },
    {
        id: 'sef-7',
        type: 'personel',
        severity: 'warning',
        title: 'Eksik Yoklama',
        message: '3 personelin bugün yoklaması alınmadı.',
        isRead: false,
        createdAt: '2026-01-16T09:00:00',
        link: '/insaat/personel',
    },
];

// Eski format uyumluluk için
export const mockNotifications = adminBildirimleri;

// Helper functions
export const getUnreadCount = (role = 'admin') => {
    const notifications = role === 'admin' ? adminBildirimleri : sefBildirimleri;
    return notifications.filter(n => !n.isRead).length;
};

export const getNotifications = (limit = 10, role = 'admin') => {
    const notifications = role === 'admin' ? adminBildirimleri : sefBildirimleri;
    return notifications.slice(0, limit);
};

export const getUnreadNotifications = (role = 'admin') => {
    const notifications = role === 'admin' ? adminBildirimleri : sefBildirimleri;
    return notifications.filter(n => !n.isRead);
};

export default mockNotifications;
